import CMS from "netlify-cms-app";
import posts from "./collections/posts";

import programme from "./collections/programme";
import prog_settings from "./collections/programme_settings";
import settings from "./collections/settings";

window.CMS_MANUAL_INIT = true;

CMS.init({
  config: {
    load_config_file: false,
    backend: {
      publish_mode: "editorial_workflow",
      name: "git-gateway",
      branch: "development", //Changed to allow testing
      repo: "simpleSite",
      commit_messages: {
        create: "Create {{collection}} “{{slug}}”",
        update: "Update {{collection}} “{{slug}}”",
        delete: "Delete {{collection}} “{{slug}}”",
        uploadMedia: "[skip ci] Upload “{{path}}”",
        deleteMedia: "[skip ci] Delete “{{path}}”",
      },
    },
    media_folder: "static/img",
    public_folder: "../../static/img",

    collections: [posts, programme, prog_settings, settings],
  },
});
